import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInAnonymously,
  linkWithPopup,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';

// Public Firebase web config. The API key is a browser key — not a secret
// (it ships in every Firebase web app); access control is Firestore security
// rules + Identity Platform. Server auth is separate (service account + ID
// token verification via google-auth in backend/app/auth.py).
export const firebaseConfig = {
  apiKey: 'AIzaSyBFlg9cRURW5zUNEWcS8rZ2AMryFD1rElY', // Browser key (auto created by Firebase)
  authDomain: 'property-sauce.web.app', // serves /__/auth/handler
  projectId: 'property-sauce',
};

export const app = initializeApp(firebaseConfig);

// Firestore native database is named 'sydney' (australia-southeast1), not
// the default. See infra/terraform/main.tf + gcloud databases list.
// NOTE: in firebase SDK >=10 the databaseId is the THIRD positional arg;
// settings.databaseId is ignored (silently falls back to (default)).
export const db = initializeFirestore(app, {}, 'sydney');

export const auth = getAuth(app);

export { GoogleAuthProvider, signInWithPopup, signInAnonymously, linkWithPopup, signOut, onAuthStateChanged };

// ── Guest session orchestration ────────────────────────────────────────────
// A guest is a Firebase anonymous account (auto-created on first visit). Rules
// treat guests as signed-in users, so the whole free flow works; backend
// /api/* calls are rejected server-side (require_bearer → 403).
//
// The sign-out flag: real users who sign out should land on the login screen,
// NOT on a fresh guest session ("where did my list go"). Persisted so it
// survives reloads; cleared when a real (non-anonymous) user is present.
const SIGNED_OUT_KEY = 'ps_signed_out';

export function markUserInitiatedSignOut() {
  localStorage.setItem(SIGNED_OUT_KEY, '1');
}

export function clearSignedOutFlag() {
  localStorage.removeItem(SIGNED_OUT_KEY);
}

export function wasSignedOut() {
  return localStorage.getItem(SIGNED_OUT_KEY) === '1';
}

export function isGuest(user) {
  return !!user?.isAnonymous;
}
